'use strict'

// requires jQuery on page
// ToDo: Performance: this function should maybe be debounced. Also I don't think jQuery will get passive event listeners in .scroll() until jQuery4.0.
export default function () {
    $(window).on('scroll', function () {
        checkScroll();
    });
}

function checkScroll() {
    var offset = $('#site-wide-messages').outerHeight();
    if ($(window).scrollTop() > offset) {
        $('.main-navigation').addClass('is-scrolling');
    } else {
        $('.main-navigation').removeClass('is-scrolling');
    }
}
